module.exports = __webpack_public_path__ + "img/buddy_antenna-02.ac932c18.svg";